package com.upcominds.expedite.features.energy

import com.upcominds.expedite.dto.*
import kotlin.math.round

// Explicit order also protects older cached responses and backend migrations.
private val metricOrder = listOf("electricity_consumption_kwh", "temperature_c", "co2_ppm", "relative_humidity_percent", "power_consumption_kw", "electrical_load_kva")
fun CommunityEnergyDTO.buildingMetrics(): List<BuildingMetricDTO> =
    if (metrics.isNotEmpty()) metrics.sortedBy { metricOrder.indexOf(it.id).takeIf { it >= 0 } ?: Int.MAX_VALUE }
    else listOf(BuildingMetricDTO("electricity_consumption_kwh", "Energy", "kWh", "SUM",
        readings.map { DailyBuildingReadingDTO(it.periodStart, it.periodEnd, it.consumptionKwh) }))

fun BuildingMetricDTO.summary(readings: List<DailyBuildingReadingDTO>): Double? =
    if (readings.isEmpty()) null else if (summaryType == "SUM") readings.sumOf { it.value } else readings.map { it.value }.average()

fun BuildingMetricDTO.format(value: Double): String =
    if (unit == "kWh") formatEnergyKwh(value) else (round(value * 1000) / 1000).toString()

// Bars share a true zero baseline, including temperatures below zero.
internal data class BuildingChartScale(val minimum: Double, val maximum: Double) {
    val range: Double get() = (maximum - minimum).coerceAtLeast(0.001)
    val zeroFraction: Double get() = if (minimum == 0.0 && maximum == 0.0) 1.0 else maximum / range
    fun heightFraction(value: Double): Double = kotlin.math.abs(value) / range
    fun topFraction(value: Double): Double = zeroFraction - if (value >= 0) heightFraction(value) else 0.0

    companion object {
        fun from(readings: List<DailyBuildingReadingDTO>): BuildingChartScale = BuildingChartScale(
            readings.minOfOrNull { it.value }?.coerceAtMost(0.0) ?: 0.0,
            readings.maxOfOrNull { it.value }?.coerceAtLeast(0.0) ?: 0.0
        )
    }
}
